import { useEffect, useState } from "react";
import { Link, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { Box, Card, CardContent, Tab, Tabs, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { useInvoiceRepository } from "../../../api/repositories/InvoiceRepository";
import InvoiceDetails from './InvoiceDetails';
import { useRouteMatch } from "../../../utils/RouteMatch";
import InvoiceLinkedTable from "../tables/InvoiceLinkedTable";
import { ID_CREDIT_NOTE, ID_INVOICE } from "../constants/InvoicesTypes";
import { useHasScope } from "../../../../../config/globalConfig";
import { RECEIVABLE_LINKED_DOCUMENT } from "../../../utils/FinanceScope";
import { STATE_CUSTOMER_IN_URL } from "../constants/InvoicesRecoil";
import { useRecoilState } from "recoil";

const InvoicePreview = () => {

    const { id } = useParams();

    const { t } = useTranslation("finance", { keyPrefix: "invoices" });
    const hasScope = useHasScope;
    const [customerInUrl, setCustomerInUrl] = useRecoilState(STATE_CUSTOMER_IN_URL);
    const navigate = useNavigate();
    const { getInvoiceById } = useInvoiceRepository();

    const [invoice, setInvoice] = useState<any>(undefined);
    const [invoiceParent, setInvoiceParent] = useState<any>(undefined);


    useEffect(() => {
        if (id) {

            getInvoiceById(id).then((data) => {
                setInvoice(data.result);

                if (data.result.documentType !== ID_INVOICE) {

                    getInvoiceById(data.result.parentId).then(parentData => {
                        setInvoiceParent(parentData.result);
                    }, () => navigate('/finance/invoices'));
                }
            }, () => navigate('/finance/invoices'));
        } else {
            navigate('/finance/invoices');
        }
    }, []);

    let ROUTING = [
        { id: 0, name: t('preview.tabs.details'), pathname: `/finance/invoices/${id}`, visible: true }
    ];

    if (hasScope(RECEIVABLE_LINKED_DOCUMENT)){ 
        ROUTING.push({ id: 1, name: t('preview.tabs.linked-documents'), pathname: `/finance/invoices/${id}/linked-documents`, visible: true })
    }

    const routeMatch = useRouteMatch(ROUTING.map(it => it.pathname));
    const currentTab = routeMatch?.pattern?.path;

    return (
            <Card variant="outlined" sx={{ margin: '15px' }}>
                { invoice && <CardContent>
                    <Box style={{ display: 'flex', alignItems: 'center', gap: '1ch' }}>
                        {/*<ArrowBackRoundedIcon onClick={() => {*/}
                        {/*    if(customerInUrl){*/}
                        {/*        navigate('/finance/invoices/?customerId=' + customerInUrl);*/}
                        {/*    } else {*/}
                        {/*        navigate('/finance/invoices');*/}
                        {/*    }                */}
                        {/*}}/>*/}
                        <Typography variant={'body1'} fontWeight={'bold'}>
                            {t('preview.buttons.' + invoice?.documentType, {  invoiceNumber: invoice?.sapInvoiceNumber || invoice?.invoiceNumber })}
                        </Typography>
                    </Box>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={currentTab ? currentTab : false}>
                            {ROUTING.filter(it => it.visible).map(it => <Tab key={it.id} label={it.name} value={it.pathname} to={it.pathname} component={Link}/>)}
                        </Tabs>
                    </Box>
                    {invoice &&
                            <Routes>
                                <Route path="/" element={<InvoiceDetails invoice={invoice} invoiceParent={invoice.documentType === ID_CREDIT_NOTE ? invoiceParent : undefined} editable={false}
                                                                         preview={false}/>}/>
                                {hasScope(RECEIVABLE_LINKED_DOCUMENT) &&                                     
                                <Route path="/linked-documents" element={<InvoiceLinkedTable invoice={invoice} invoiceParent={invoiceParent}/>}/>
                                }  
                            </Routes>
                    }
                </CardContent> }
            </Card>
    )
}

export default InvoicePreview;